<template>
  <div class="form-wrapper">
    <el-form :model="ruleform" class="popup" :rules="rules" ref="ruleform">
      <zj-layout-container class="content video-monitor passflow">
        <div class="leftNav">
          <div class="leftSpot"></div>
          <div class="leftNav_title">
            客流设备列表
            <div class="title_btmLine"></div>
          </div>
          <el-input
            placeholder="搜索监控点"
            class="nav-tree-filter"
            v-model="filterText"
          ></el-input>
          <div class="nav-tree-content">
            <el-tree
              style="height: 100%"
              v-loading="loading"
              :element-loading-text="loadingText"
              @node-click="nodeClick"
              lazy
              :load="loadNode"
              node-key="id"
              :props="defaultProps"
              :filter-node-method="filterNode"
              class="zj-demo-player-tree-device-tree"
              ref="tree"
            ></el-tree>
          </div>
        </div>
        <!-- 右侧内容 -->
        <div class="rightContent">
          <div class="topContent">
            <!-- 分屏是一个的时候开始 -->
            <div class="oneVideoBox">
              <div class="showOneVideo">
                <div style="width: 100%; height: 100%">
                  <flv-player-real-time
                    ref="childOneVideo"
                    class="videoBig-item"
                    :cameraId="cameras.cameraId"
                    :cameraName="cameras.cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                    :cameraIsOnline="cameras.cameraIsOnline"
                  />
                </div>
              </div>
            </div>
            <div class="chart_data">
              <div id="chart" class="analysis_chart"></div>
            </div>
            <div class="table_data">
              <div class="zj-table-container">
                <el-table
                  :data="tableData"
                  ref="multipleTable"
                  border
                  style="width: 100%"
                  fixed
                >
                  <el-table-column
                    type="index"
                    label="序号"
                    width="80"
                    align="center"
                  ></el-table-column>
                  <el-table-column
                    prop="startTime"
                    label="时间"
                  ></el-table-column>
                  <el-table-column
                    prop="outCountNum"
                    label="出（人数）"
                  ></el-table-column>
                  <el-table-column
                    prop="inCountNum"
                    label="进（人数）"
                  ></el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
      </zj-layout-container>
    </el-form>
  </div>
</template>
<script>
import { mapActions } from "vuex";

import {
  getEquipmentCode,
  listEquipment,
  listEquipmentArea,
  listPassengerFlowHour,
  listPassengerFlow,
} from "@/api/src/equipment";

export default {
  name: "PassengerflowView",
  controller: "UI",
  action: "PassengerflowView",
  components: {
    // VideoMonitorControl
  },
  data() {
    return {
      filterText: "",
      loading: false,
      loadingText: "",
      nodes: [],
      autoplay: true,
      defaultProps: {
        children: "children",
        label: "label",
        status: "status",
        isLeaf: "leaf",
      },
      cameras: {
        cameraId: "",
        cameraName: "",
        cameraIsOnline: "",
      },
      tableData: [],
      mc: "",
      equCode: null,
      treeClickCount: 0,
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  created() {},
  mounted() {
    this.submitIsShowbg(false);

    this.drawFlowChart();

    // this.handleLoad();
    this.logInfo.ActionName = "实时客流查看";
    this.logInfo.LogMessage = "实时客流查看";
    this.logInfo.ModuleName = "客流监控";
    this.logInfo.PageName = "实时客流页面";
    this.addOperationLog();
  },
  methods: {
    ...mapActions(["submitIsShowbg"]),

    loadNode(node, resolve) {
      console.log("节点", node, node.level);
      if (node.level === 0) {
        this.getRegionTree(resolve);
      }
      if (
        node.level > 0 &&
        node.data &&
        node.data.children &&
        node.data.children.length > 0
      ) {
        return resolve(node.data.children);
      } else if (node.level > 0 && node.data) {
        this.initMonitor(node.data.code, resolve);
      }
    },
    getRegionTree(resolve) {
      getEquipmentCode("passenger-flow-code").then((response) => {
        this.equCode = response.data;
        listEquipmentArea({ categoryCode: this.equCode, pageSize: 100 }).then(
          (response) => {
            const nodes = [];
            if (response.data) {
              response.data.forEach((item) => {
                nodes.push({
                  label: item.areaName,
                  id: item.id,
                  code: item.areaCode,
                  type: "Area",
                });
              });
            }
            resolve(nodes);
          }
        );
      });
    },
    // 获取设备
    initMonitor(areaCode, resolve) {
      this.loading = true;
      listEquipment({
        areaCode: areaCode,
        categoryCode: this.equCode,
        pageSize: 10000,
      }).then((response) => {
        const nodes = [];
        if (response.rows) {
          response.rows.forEach((item) => {
            nodes.push({
              label: item.equipmentName,
              id: item.equipmentCode || item.id,
              leaf: true,
              data: item,
              type: "monitor",
              status: item.onlineStatus,
            });
          });
        }
        this.loading = false;

        resolve(nodes);
      });
    },

    getPassengerFlowList(equipmentCode) {
      listPassengerFlow({
        equipmentCode: equipmentCode,
        statDay: new Date().format("yyyyMMdd"),
        pageSize: 100000,
      }).then((response) => {
        this.tableData = response.rows;
        this.total = response.total;
      });
    },

    getChartData(equipmentCode) {
      listPassengerFlowHour({
        equipmentCode: equipmentCode,
        statDay: new Date().format("yyyyMMdd"),
        pageSize: 100000,
      }).then((response) => {
        // this.tableData = response.data;
        let tempChartData = {},
          xAxis = [],
          yAxisIn = [],
          yAxisOut = [];
        response.data.forEach((item) => {
          xAxis.push(item.hour);
          yAxisIn.push(item.inCountNum);
          yAxisOut.push(item.outCountNum);
        });
        tempChartData = { xAxis: xAxis, yAxisIn: yAxisIn, yAxisOut: yAxisOut };
        this.drawFlowChart(tempChartData);
        console.log("客流统计2", response.data);
      });
    },

    // eslint-disable-next-line no-unused-vars
    nodeOneClick: function (data, node, self) {
      if (node.level == 2) {
        this.cameras.cameraId = data.id;
        this.cameras.cameraName = data.label;
        this.cameras.cameraIsOnline = data.status;
        this.getPassengerFlowList(data.id);
        this.getChartData(data.id);
      }
    },
    nodeClick: function (data, node, self) {
      //记录点击次数
      this.treeClickCount++;
      //单次点击次数超过2次不作处理,直接返回,也可以拓展成多击事件
      if (this.treeClickCount >= 2) {
        return;
      }
      //计时器,计算300毫秒为单位,可自行修改
      this.timer = window.setTimeout(() => {
        if (this.treeClickCount == 1) {
          //把次数归零
          this.treeClickCount = 0;
          //单击事件处理
        } else if (this.treeClickCount > 1) {
          //把次数归零
          this.treeClickCount = 0;

          if (node.level > 1 && node.data.type === "monitor") {
            this.cameras.cameraId = data.id;
            this.cameras.cameraName = data.label;
            this.cameras.cameraIsOnline = data.status;
            this.getPassengerFlowList(data.id);
            this.getChartData(data.id);
          }
        }
      }, 300);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },

    drawFlowChart: function (r) {
      r = r || {};
      var defaultOption = {
        title: {
          text: "客流量走势图",
          textStyle: {
            color: "#d6f0ff",
          },
          left: "10%",
        },
        grid: {
          left: "10%",
          right: "15%",
          top: "25%",
          bottom: "5%",
          containLabel: true,
        },
        tooltip: [
          {
            trigger: "axis",
            // formatter: "{b} <br />{a0}: {c0} 人<br />{a1}: {c1} 人",
          },
        ],
        series: [
          {
            name: "入",
            type: "line",
            smooth: true,
            data: r.yAxisIn || [0],
            color: ["#449d44"],
          },
          {
            name: "出",
            type: "line",
            smooth: true,
            data: r.yAxisOut || [0],
            color: ["#31b0d5"],
          },
        ],
        legend: [
          {
            data: ["入", "出"],
            textStyle: {
              color: "#d6f0ff",
            },
          },
        ],
        yAxis: [
          {
            name: "人数",
            type: "value",
            min: 0,
            minInterval: 1,
            nameTextStyle: {
              color: "#d6f0ff",
              //fontSize: 12
            },
            axisLine: {
              lineStyle: {
                color: "#00bcfe",
              },
            },
            splitLine: {
              lineStyle: {
                color: "#257dd4",
              },
            },
            axisLabel: {
              textStyle: {
                //fontSize: 12,
                color: "#d6f0ff",
              },
            },
          },
        ],
        xAxis: [
          {
            name: "时间(h)",
            type: "category",
            boundaryGap: false,
            nameTextStyle: {
              color: "#d6f0ff",
              //fontSize: 12
            },
            axisLine: {
              lineStyle: {
                color: "#00bcfe",
              },
            },
            splitLine: {
              lineStyle: {
                color: "#257dd4",
              },
            },
            axisLabel: {
              textStyle: {
                //fontSize: 12,
                color: "#d6f0ff",
              },
            },
            data: r.xAxis || [],
          },
        ],
      };

      var chartDom = document.getElementById("chart");
      // eslint-disable-next-line no-undef
      var myChart = echarts.getInstanceByDom(chartDom);
      if (!myChart) {
        // eslint-disable-next-line no-undef
        myChart = echarts.init(chartDom);
        myChart.setOption(defaultOption);
      }
      myChart.clear();
      myChart.setOption(defaultOption);

      window.onresize = function () {
        var chartDom = document.getElementById("chart");
        // eslint-disable-next-line no-undef
        var myChart = echarts.getInstanceByDom(chartDom);
        if (myChart) {
          myChart.resize();
        }
      };
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm");
    },
  },
  destoryed() {
    this.submitIsShowbg(true);
  },
};
</script>

<style scoped >
.video-monitor.passflow {
  overflow: hidden !important;
}
/* .rightContent {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.topContent {
  flex: 1;
  overflow: hidden;
  width: 100%;
}
.bottomContent {
  width: 100%;
  height: 9.3rem;
  background-color: #003669;
  border-radius: 0.6rem;
  border: solid 0.1rem #91a0a5;
  margin-top: 2rem;
  position: relative;
} */

/* 选择一个视频 */
.oneVideoBox {
  width: 40%;
  height: 50%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  float: left;
}
/* 左侧展示视频 */
.showOneVideo {
  flex: 1;
  height: 100%;
  background-color: black;
  border: solid 0.1rem #31cdc0;
  overflow: hidden;
}

.video-wrapper {
  width: 100%;
  height: 100%;
}

.videoBig-item {
  width: 100%;
  height: 100%;
}

.chart_data {
  width: 60%;
  height: 50%;
  float: left;
  overflow: hidden;
}

.chart_data .chart {
  width: 100%;
  height: 100%;
}

.table_data {
  width: 100%;
  height: 50%;
  padding-top: 1rem;
  overflow: hidden;
  float: left;
}

.table_data .zj-table-container {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

.table_data .zj-table-container .zj-camera-player {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>